import React from 'react';

import PreloadHelmetLinks from '../../../../components/PreloadHelmetLinks';
import {getBannerPreloadImages} from './helper';

const ListingPreloadImages = ({
  isBannerActive,
  bannerFragment,
  productImages,
  preloadRetinaImages = true
}) => {
  if (isBannerActive) {
    const banner = bannerFragment?.preloadBannerImage;

    if (banner) {
      const preloadBanners = getBannerPreloadImages({banner, preloadRetinaImages})

      return (
        <PreloadHelmetLinks images={preloadBanners} />
      )
    }

    return '';
  }

  if (productImages?.length > 0) {
    return (
      <PreloadHelmetLinks images={productImages} />
    )
  }

  return '';
}

export default ListingPreloadImages;
